export default "__VITE_ASSET__TWW5EQvu__"